import { Injectable, NgModule, Injector } from '@angular/core'
//import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { HttpRequest } from '@angular/common/http'
import { Observable, of } from 'rxjs'

import { CoreService } from '@core/core.service'
//import { SecurityOauth2Service } from "@core/security-oaut2.service";

//-- Store --//
import { select, Store } from '@ngrx/store'
import { AppState } from '@data/store/storage.module'
import * as StageActions from '@data/store/stage/stage.actions'
import { ConfigService } from './shared/services/config.service'
import { Router } from '@angular/router'

@Injectable()
export class AppService {
   console: boolean = this.core.modeDevel
   logPrefix: string = '@app - ' + this.constructor.name

   public tmpData: any = {}

   constructor(
      public core: CoreService,
      private store: Store<AppState>,
      private router: Router
   ) { }


   goToEditProfile() {
      this.core.nav.goToRoute('/account')
   }

   getDataState() {
      if (this.console) console.log(this.logPrefix, 'getDataState')

      return {
         noData: true,
         loading: false,
         error: false,
         filtered: false,
      }
   }

   //-- Menu Status --//

   addBreadcrumb(label: string, route: string = '', translate: boolean = true) {
      if (this.console) console.log(this.logPrefix, 'addBreadcrumb')

      let breadcrumb = {
         label: label,
         route: route,
         translate: translate,
      }

      this.store.dispatch(StageActions.addBreadcrumb({ breadcrumb }))
   }

   clearBreadcrumbs() {
      if (this.console) console.log(this.logPrefix, 'clearBreadcrumbs')

      this.store.dispatch(StageActions.clearBreadcrumbs())
   }

   //-- Lists --//

   setLists(value: any) {
      var storeReply = this.core.store.setData('InnplaceLists', value)
      return !storeReply.error
   }

   getLists() {
      var storeReply = this.core.store.getData('InnplaceLists')
      return !storeReply.error ? storeReply.result : []
   }

   clearLists() {
      var storeReply = this.core.store.removeData('InnplaceLists')
      return storeReply.result
   }

   getListPNOSectors() {
      const list = this.getLists()
      return list ? list.pno_sectors : []
   }

   getListServices() {
      const list = this.getLists()
      return list ? list.services : []
   }

   getListGrants() {
      const list = this.getLists()
      return list ? list.grant_programmes : []
   }

   getListCountries() {
      const list = this.getLists()
      return list ? list.regions : []
   }

   getListClientTypes() {
      const list = this.getLists()
      return list ? list.type : []
   }

   setListsNames() {
      let namesObj = {}

      for (let row of this.getListPNOSectors()) namesObj['pno_sectors_' + row.id] = row.name
      for (let row of this.getListServices()) namesObj['services_' + row.id] = row.name
      for (let row of this.getListGrants()) namesObj['grants_' + row.id] = row.name

      var storeReply = this.core.store.setData('InnplaceListsNames', namesObj)
      return !storeReply.error
   }

   clearListsNames() {
      var storeReply = this.core.store.removeData('InnplaceListsNames')
      return storeReply.result
   }

   getListsNames() {
      var storeReply = this.core.store.getData('InnplaceListsNames')
      return !storeReply.error ? storeReply.result : {}
   }

   getListName(type: string, id: number) {
      if (type && id) {
         let namesObj = this.getListsNames()

         let nameKey = type + '_' + id

         return namesObj && namesObj.hasOwnProperty(nameKey) ? namesObj[nameKey] : 'Undefined'
      }
      return 'Undefined'
   }

   saveFile(fileName: string, fileData: any) {
      if (fileName && fileData) {
         let a = document.createElement('a')
         document.body.appendChild(a)

         let blob = new Blob([fileData], { type: fileData.type }),
            url = window.URL.createObjectURL(blob)

         fileName = fileName.replace(/ /gi, '_')

         switch (fileData.type) {
            case 'application/pdf':
               fileName += '.pdf'
               break
            case 'application/msword':
               fileName += '.doc'
               break
            case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
               fileName += '.docx'
               break
            case 'application/rtf':
               fileName += '.rtf'
               break
         }

         a.href = url
         a.download = fileName
         a.click()
         window.URL.revokeObjectURL(url)

         return true
      }
      return false
   }
}

//-- CORE: AppService Global Ref --//

export let $app: AppService

@NgModule({
   providers: [AppService],
})
export class AppServiceModule {
   constructor(public appService: AppService) {
      $app = this.appService
   }
}

